import {Link} from "react-router-dom";
import {ProductStars} from "./Stars";
import {useI18n} from "./I18nProvider";

type Props = {
  brand: string;
  brandUrl: string;
  title: string;
  reviewStars: number;
  reviewCount: number;
  sku: string;
  inWishlist?: boolean;
  onWishlist?: (e: React.MouseEvent) => void | Promise<void>;
};

export function PdpProductHead({brand, brandUrl, title, reviewStars, reviewCount, sku, inWishlist, onWishlist}: Props) {
  const {t} = useI18n();
  return (
    <div className="pvProductHead">
      {onWishlist ? (
        <button
          type="button"
          className={`pvProductHead__wish pvBuyWishBtn anim pvProductHead__wish--desktop${inWishlist ? " isActive" : ""}`}
          aria-label="Wishlist"
          aria-pressed={!!inWishlist}
          onClick={onWishlist}
        >
          <i className={`fa${inWishlist ? " fa-heart" : " fa-heart-o"}`} aria-hidden="true" />
        </button>
      ) : null}
      <p className="pvProductBrand"><Link to={brandUrl}>{brand}</Link></p>
      <h1 className="pvProductTitle">{title}</h1>
      <div className="pvProductRatingRow">
        <div className="pvProductRating">
          <ProductStars stars={reviewStars} count={reviewCount} />
        </div>
        <span className="pvProductSku">{t("SKU")}: {sku}</span>
      </div>
    </div>
  );
}
